// KHUNG GIỜ CHẠY theo giá AI (14/10/2026). DeepSeek tính giá GẤP ĐÔI trong giờ cao điểm: 01:00–04:00 và 06:00–10:00 UTC, thứ Hai–thứ Sáu
// (= 08:00–11:00 và 13:00–17:00 giờ Việt Nam, T2–T6; thứ Bảy, Chủ nhật và mọi giờ còn lại là thấp điểm — ngày lễ Trung Quốc cũng thấp điểm nhưng
// không tính ở đây). Người dùng chốt: ở form hẹn giờ để sẵn HAI khung — "giờ thấp điểm" (nhiều tương tác hơn, khuyên chọn) và "giờ cao điểm"
// (ít tương tác hơn). Chạy 13/10: ~64% lần gọi AI rơi vào cao điểm.
export type KhungGioAi = "thap_diem" | "cao_diem" | "hon_hop";

/** Các khoảng CAO ĐIỂM trong ngày thường (T2–T6), theo phút kể từ 00:00 giờ Việt Nam: [bắt đầu, hết). */
export const KHOANG_CAO_DIEM_VN: readonly (readonly [number, number])[] = [[8 * 60, 11 * 60], [13 * 60, 17 * 60]];
export const GIO_THAP_DIEM_MAC_DINH = "20:00"; // tối: người dùng mạng xã hội hoạt động nhiều
export const GIO_CAO_DIEM_MAC_DINH = "09:00";
export const CHU_KHUNG_THAP_DIEM = "Giờ thấp điểm: 17:00 – 08:00 hằng ngày và cả ngày thứ Bảy, Chủ nhật — AI rẻ hơn một nửa, thường nhiều tương tác hơn (khuyên chọn khung này)";
export const CHU_KHUNG_CAO_DIEM = "Giờ cao điểm: 08:00 – 11:00 và 13:00 – 17:00 thứ Hai – thứ Sáu — AI giá gấp đôi, thường ít tương tác hơn";

export function phutCuaHhmm(hhmm: string): number | null {
  const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(String(hhmm ?? "").trim());
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

/** Lần chạy BẮT ĐẦU lúc `hhmm` rồi trễ ngẫu nhiên 0..`lech` phút có chạm khoảng cao điểm của ngày thường không. */
function chamCaoDiem(batDau: number, lech: number): boolean {
  const het = batDau + Math.max(0, lech);
  return KHOANG_CAO_DIEM_VN.some(([a, b]) => batDau < b && het >= a);
}

/**
 * Giờ `hhmm` (giờ Việt Nam) rơi vào khung nào, xét các ngày `thu` (1 = T2 … 7 = CN; rỗng/không có = cả tuần) và độ lệch ngẫu nhiên `lech` phút:
 * mọi ngày đều thấp điểm → "thap_diem"; mọi ngày đều chạm cao điểm → "cao_diem"; lẫn lộn (vd. cả tuần mà giờ 09:00: T2–T6 cao điểm, T7/CN thấp) → "hon_hop".
 * Giờ không hợp lệ → null.
 */
export function khungGioAi(hhmm: string, thu?: readonly number[], lech = 0): KhungGioAi | null {
  const p = phutCuaHhmm(hhmm);
  if (p === null) return null;
  const ngay = thu && thu.length ? thu : [1, 2, 3, 4, 5, 6, 7];
  const cao = chamCaoDiem(p, lech);
  let nCao = 0;
  for (const d of ngay) if (d >= 1 && d <= 5 && cao) nCao++;
  return nCao === 0 ? "thap_diem" : nCao === ngay.length ? "cao_diem" : "hon_hop";
}

/** Câu ngắn nói khung của giờ đang chọn (hiện dưới ô giờ). */
export function chuKhungGioAi(k: KhungGioAi | null): string {
  if (k === "thap_diem") return "Đang chọn giờ THẤP điểm — AI rẻ hơn một nửa, thường nhiều tương tác hơn (khuyên chọn).";
  if (k === "cao_diem") return "Đang chọn giờ CAO điểm — AI giá gấp đôi, thường ít tương tác hơn. Nên chuyển sang giờ thấp điểm (tối, sáng sớm hoặc cuối tuần).";
  if (k === "hon_hop") return "Giờ này CAO điểm vào thứ Hai – thứ Sáu (AI giá gấp đôi, ít tương tác hơn) nhưng thấp điểm cuối tuần.";
  return "";
}

/** (16/10/2026) GIÃN LỊCH CỦA KỊCH BẢN KHO MẪU — nick mới / chạy dồn dập dễ bị Facebook, TikTok bắt xác minh danh tính (selfie) hoặc khoá tạm. Lịch tạo từ Kho mẫu: mỗi ngày chạy trễ
 *  ngẫu nhiên 0–30 phút (không đúng giờ tròn mỗi ngày), nhiều bot cùng lịch bắt đầu lệch nhau ngẫu nhiên tới 10 phút (không cùng bấm một lúc). */
export const LECH_LICH_MAU_PHUT = 30;
export const GIAN_CACH_LICH_MAU_S = 600;
